// extracted by mini-css-extract-plugin
module.exports = {"declaration":"lMvjpSjf0E7fvp2mFAxHWQ==","footer":"_2M3USHfAiQH2RYZ-Ow1ALw=="};